import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Linkedin, ArrowUpIcon } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <footer className="bg-brand-dark text-white pt-16 pb-8 border-t-4 border-brand-red" data-id="element-87">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-88">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-89">
          {/* Brand */}
          <div data-id="element-90">
            <div className="flex items-center gap-3 mb-6" data-id="element-91">
              <img src="https://cdn.magicpatterns.com/uploads/ocQwAnLv8ZRS6ZM4MrGo2A/LOGO_-_ELITE_-_DORADO.png" alt="Elite Property Adjusters LLC Logo" className="h-16 w-auto" data-id="element-92" />
              <div className="flex flex-col" data-id="element-93">
                <span className="font-heading font-black text-3xl tracking-wider text-white" data-id="element-94">
                  ELITE
                </span>
                <span className="text-[0.6rem] font-bold tracking-widest uppercase text-brand-gold" data-id="element-95">
                  Property Adjusters LLC
                </span>
              </div>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed" data-id="element-96">
              {t.footer.desc}
            </p>
            <div className="flex space-x-4" data-id="element-97">
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand-red transition-colors" data-id="element-98">
                <Facebook size={20} data-id="element-99" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand-red transition-colors" data-id="element-100">
                <Twitter size={20} data-id="element-101" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand-red transition-colors" data-id="element-102">
                <Instagram size={20} data-id="element-103" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand-red transition-colors" data-id="element-104">
                <Linkedin size={20} data-id="element-105" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-106">
            <h4 className="text-lg font-bold mb-6 text-brand-gold uppercase tracking-wider" data-id="element-107">
              {t.footer.quick}
            </h4>
            <ul className="space-y-3" data-id="element-108">
              <li data-id="element-109">
                <a href="#home" className="text-gray-400 hover:text-white transition-colors" data-id="element-110">
                  {t.nav.home}
                </a>
              </li>
              <li data-id="element-111">
                <a href="#services" className="text-gray-400 hover:text-white transition-colors" data-id="element-112">
                  {t.nav.services}
                </a>
              </li>
              <li data-id="element-113">
                <a href="#about" className="text-gray-400 hover:text-white transition-colors" data-id="element-114">
                  {t.nav.about}
                </a>
              </li>
              <li data-id="element-115">
                <a href="#process" className="text-gray-400 hover:text-white transition-colors" data-id="element-116">
                  {t.nav.process}
                </a>
              </li>
              <li data-id="element-117">
                <a href="#testimonials" className="text-gray-400 hover:text-white transition-colors" data-id="element-118">
                  {t.nav.testimonials}
                </a>
              </li>
              <li data-id="element-119">
                <a href="#contact" className="text-gray-400 hover:text-white transition-colors" data-id="element-120">
                  {t.nav.contact}
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-121">
            <h4 className="text-lg font-bold mb-6 text-brand-gold uppercase tracking-wider" data-id="element-122">
              {t.footer.services}
            </h4>
            <ul className="space-y-3" data-id="element-123">
              {t.services.items.map((item, i) => <li key={i} className="text-gray-400" data-id="element-124">
                  {item.title}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-125">
          <div className="text-gray-500 text-sm" data-id="element-126">
            <p data-id="element-127">
              &copy; {new Date().getFullYear()} Elite Property Adjusters LLC.{' '}
              {t.footer.rights}
            </p>
            <p className="mt-1 text-gray-600" data-id="element-128">
              Licensed Public Adjuster Firm — W820520
            </p>
          </div>
          <div className="flex space-x-6 text-sm text-gray-500" data-id="element-129">
            <Link to="/privacy-policy" className="hover:text-white transition-colors" data-id="element-130">
              {t.footer.privacy}
            </Link>
            <Link to="/terms-of-service" className="hover:text-white transition-colors" data-id="element-131">
              {t.footer.terms}
            </Link>
          </div>
        </div>

        {/* Back to Top Button */}
        <div className="flex justify-center mt-8" data-id="element-132">
          <button onClick={scrollToTop} className="group w-12 h-12 bg-brand-red hover:bg-brand-darkred rounded-full flex items-center justify-center shadow-lg shadow-brand-red/30 transition-all duration-300 hover:-translate-y-1" aria-label="Back to top" data-id="element-133">
            <ArrowUpIcon className="text-white group-hover:scale-110 transition-transform" size={20} data-id="element-134" />
          </button>
        </div>
      </div>
    </footer>;
}